import React, { useContext, useState } from "react";


const ReportContext = React.createContext();

export function useReport() {
	return useContext(ReportContext);
}

export function ReportProvider({ children }) {
	const [reportForm, setReportForm] = useState({
		carData: {
			id: null,
			patent: null,
			year: null,
			kilometers: null,
			brandId: null,
			brandName: null,
			modelId: null,
			modelName: null,
			codia: null,
			description: null,
			position: null,
			photo_url: null,
		},
		carLocation: {
			province: null,
			provinceName: null,
			locality: null,
			localityName: null,
			postalCode: null,
		},
		carSpecialFeatures: {
			hasGNC: null,
			isZeroKm: null,
			hasGarage: null,
			hasGPS: null,
			typeOfUseId: null,
		},
		quotationPersonalData: {
			name: null,
			lastName: null,
			birthday: null,
			telephone: null,
		},
		quotationData: {
			quotationId: null,
		},
		emissionPersonalData: {
			typeOfDocumentId: null,
			documentNumber: null,
			civilStateId: null,
			genreId: null,
			address: null,
			carPatent: null,
			carMotor: null,
			carChasis: null,
		},
		emissionPaymentMethod: {},
		titularActual: null,
		automotor: null,
		backStep: null,
	});

	const updateReportForm = (values, backStep) => {
		const carData = {
			patent: values?.patent ?? reportForm.carData.patent,
			kilometers: values?.kilometers ?? reportForm.carData.kilometers,
			year: values?.year ?? reportForm.carData.year,
			brandId: values?.brandId ?? reportForm.carData.brandId,
			brandName: values?.brandName ?? reportForm.carData.brandName,
			modelId: values?.modelId ?? reportForm.carData.modelId,
			modelName: values?.modelName ?? reportForm.carData.modelName,
			codia: values?.codia ?? reportForm.carData.codia,
			description: values?.description ?? reportForm.carData.description,
			position: values?.position ?? reportForm.carData.position,
			photo_url: values?.photo_url ?? reportForm.carData.photo_url,
		};

		const carLocation = {
			province: values?.province ?? reportForm.carLocation.province,
			provinceName: values?.provinceName ?? reportForm.carLocation.provinceName,
			locality: values?.locality ?? reportForm.carLocation.locality,
			localityName: values?.localityName ?? reportForm.carLocation.localityName,
			postalCode: values?.postalCode ?? reportForm.carLocation.postalCode,
		};

		const carSpecialFeatures = {
			hasGNC: values?.hasGNC ?? reportForm?.carSpecialFeatures?.hasGNC,
			isZeroKm: values?.isZeroKm ?? reportForm?.carSpecialFeatures?.isZeroKm,
			hasGarage: values?.hasGarage ?? reportForm?.carSpecialFeatures?.hasGarage,
			hasGPS: values?.hasGPS ?? reportForm?.carSpecialFeatures?.hasGPS,
			typeOfUseId:
				values?.typeOfUseId ?? reportForm.carSpecialFeatures?.typeOfUseId,
		};

		const quotationPersonalData = {
			name: values?.name ?? reportForm?.quotationPersonalData?.name,
			lastName: values?.lastName ?? reportForm?.quotationPersonalData?.lastName,
			birthday: values?.birthday ?? reportForm?.quotationPersonalData?.birthday,
			telephone: values?.telephone ?? reportForm?.quotationPersonalData?.telephone,
			email: values?.email ?? reportForm?.quotationPersonalData?.email,
		};

		const quotationData = {
			quotationId:
				values?.quotationId ?? reportForm?.quotationData?.quotationId,
		};

		const emissionPersonalData = {
			typeOfDocumentId:
				values.typeOfDocumentId ??
				reportForm?.emissionPersonalData?.typeOfDocumentId,
			documentNumber:
				values?.documentNumber ??
				reportForm?.emissionPersonalData?.documentNumber,
			civilStateId:
				values?.civilStateId ?? reportForm?.emissionPersonalData?.civilStateId,
			genreId: values?.genreId ?? reportForm?.emissionPersonalData?.genreId,
			address: values?.address ?? reportForm?.emissionPersonalData?.address,
			patent: values?.patent ?? reportForm?.emissionPersonalData?.patent,
			carMotor: values?.carMotor ?? reportForm?.emissionPersonalData?.carMotor,
			carChasis:
				values?.carChasis ?? reportForm?.emissionPersonalData?.carChasis,
		};

		const emissionPaymentMethod = {
			...reportForm.emissionPaymentMethod,
			...values?.paymentMethod,
		};

		const titularActual = values?.titularActual ?? reportForm.titularActual;
		const automotor = values?.automotor ?? reportForm.automotor;

		setReportForm((prev) => ({
			...prev,
			carData: carData,
			carLocation: carLocation,
			carSpecialFeatures: carSpecialFeatures,
			quotationPersonalData: quotationPersonalData,
			quotationData: quotationData,
			emissionPersonalData: emissionPersonalData,
			emissionPaymentMethod: emissionPaymentMethod,
			titularActual: titularActual,
			automotor: automotor,
			backStep: backStep ?? reportForm.backStep,
		}));
	};

	const resetForm = () => {
		setReportForm({
			carData: {
				id: null,
				patent: null,
				year: null,
				kilometers: null,
				brandId: null,
				brandName: null,
				modelId: null,
				modelName: null,
				codia: null,
				description: null,
				position: null,
				photo_url: null,
			},
			carLocation: {
				province: null,
				provinceName: null,
				locality: null,
				localityName: null,
				postalCode: null,
			},
			carSpecialFeatures: {
				hasGNC: null,
				isZeroKm: null,
				hasGarage: null,
				hasGPS: null,
				typeOfUseId: null,
			},
			quotationPersonalData: {
				name: null,
				lastName: null,
				birthday: null,
				telephone: null,
				email: null,
			},
			quotationData: {
				quotationId: null,
			},
			emissionPersonalData: {
				typeOfDocumentId: null,
				documentNumber: null,
				civilStateId: null,
				genreId: null,
				address: null,
				carPatent: null,
				carMotor: null,
				carChasis: null,
		},
		emissionPaymentMethod: {},
			titularActual: null,
			automotor: null,
			backStep: null,
		});
	};

	const checkCarInfoCompleted = () => {
		return (
			!!reportForm.carData.brandId &&
			!!reportForm.carData.modelId &&
			!!reportForm.carData.codia &&
			!!reportForm.carData.year &&
			!!reportForm.carLocation.locality &&
			!!reportForm.carLocation.province &&
			!!reportForm.carLocation.postalCode &&
			!!reportForm.carSpecialFeatures.typeOfUseId
		);
	};

	const checkPersonalInfoCompleted = () => {
		return (
			reportForm.quotationPersonalData.name &&
			reportForm.quotationPersonalData.lastName &&
			reportForm.quotationPersonalData.birthday &&
			reportForm.quotationPersonalData.telephone
		);
	};

	const checkQuotationInfoCompleted = () => {
		return !!reportForm.quotationData.quotationId;
	};

	const value = {
		reportForm,
		setReportForm,
		updateReportForm,
		resetForm,
		checkCarInfoCompleted,
		checkPersonalInfoCompleted,
		checkQuotationInfoCompleted,
	};
	return (
		<ReportContext.Provider value={value}>{children}</ReportContext.Provider>
	);
}
